import React from 'react';
import { Image } from "@chakra-ui/react";
import messageQuestion from '../assets/message-question-circle.svg'

const Question = ({ question }) => {
    return (
        <div className="container w-full flex flex-col sm:flex-row items-center gap-3 pt-2 mb-2">
            <div className="flex items-center gap-2 sm:gap-4">
                <Image
                    src={messageQuestion}
                    alt="message"
                    width={24}
                    height={24}
                    className="w-6 h-6"
                />
                <p className="font-bold uppercase leading-[152%] text-white m-0">
                    Research Task:
                </p><br/>
            </div>
            <div
                className="grow text-white break-words max-w-full log-message text-xl text-left">&quot;{question}&quot;</div>
        </div>
    );
};

export default Question;
